import { ALIPAY_PREPAY_PAY } from "../apis/payment";
var alipayscript;
export default {
  methods: {
    loadAlipayScript() {
      if (!alipayscript) {
        alipayscript = window.document.createElement("script");
        alipayscript.src =
          "https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js";
        // alipayscript.onload = () => {
        //   this.loadWXConfig(apiList)
        // }
        var head =
          window.document.head ||
          window.document.getElementsByTagName("head")[0] ||
          window.document.documentElement;
        head.insertBefore(alipayscript, head.firstChild);
      }
    },
    // 支付宝支付
    onAliPay(paymentId) {
      const qrcode = this.qrcode || this.$route.query.cabinetID;
      const query = {
        qrcode: qrcode,
        amount: this.price,
        paymentId: paymentId
      };
      this.$loading(true);
      this.$post(
        `${ALIPAY_PREPAY_PAY}/${qrcode}`,
        query,
        resp => {
          this.$loading(false);
          console.log("alipay", resp);
          const data = resp.data;
          if (data && data.formHtml) {
            const payBox = document.createElement("div");
            payBox.innerHTML = data.formHtml;
            document.body.appendChild(payBox);
            const payForm = payBox.querySelector("form");
            if (payForm) payForm.submit();
          } else {
            this.$toast("error");
          }
        },
        error => {
          console.log("alipay error", error);
          this.$loading(false);
          this.$toast(error);
        }
      );
    }
  }
};
